import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { onboardingQuestionnaireActions } from '../../../../../../../store';
import { DOCUMENT_TYPES } from '../../../../constants';
import { getInsuranceCardDocument } from './utils';

import type { AppDispatch, RootState } from '../../../../../../../store';
import type { InsuranceDocumentSubType } from './types';

export default function useUploadInsuranceCardDocument() {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { onboardingQuestionnaireId } = useParams<'onboardingQuestionnaireId'>();
  const documents = useSelector(
    (state: RootState) => state.onboardingQuestionnaire.onboardingQuestionnaireDetails?.documents,
  );

  return useCallback(
    async (file: File, title: string, documentSubType: InsuranceDocumentSubType) => {
      if (!onboardingQuestionnaireId) {
        return;
      }

      const { deleteOnboardingQuestionnaireDocument, uploadOnboardingQuestionnaireDocument } =
        onboardingQuestionnaireActions;
      const existingDocument = getInsuranceCardDocument(documents, documentSubType);

      if (existingDocument) {
        const deleteResult = await dispatch(
          deleteOnboardingQuestionnaireDocument({
            onboardingQuestionnaireId,
            documentId: String(existingDocument.id),
            getAccessTokenSilently,
          }),
        );

        if (!deleteOnboardingQuestionnaireDocument.fulfilled.match(deleteResult)) {
          return;
        }
      }

      await dispatch(
        uploadOnboardingQuestionnaireDocument({
          onboardingQuestionnaireId,
          data: {
            file,
            title,
            document_type: DOCUMENT_TYPES.INSURANCE_CARD,
            document_sub_type: documentSubType,
          },
          getAccessTokenSilently,
        }),
      );
    },
    [dispatch, documents, getAccessTokenSilently, onboardingQuestionnaireId],
  );
}
